const features = [
  { icon: "ri-flashlight-line", title: "热点同步", text: "紧跟娱乐热点，热门大瓜不迷路，实时更新评论区风向。" },
  { icon: "ri-emotion-happy-line", title: "精选热评", text: "从海量评论中挑出最具代表性的神评，笑点密度拉满。" },
  { icon: "ri-sticky-note-line", title: "神梗段子", text: "网友玩梗造段一个比一个能说，帮你一键收藏快乐。" },
  { icon: "ri-download-cloud-line", title: "表情包仓库", text: "吃瓜斗图两不误，热门口水仗专用表情随用随取。" },
];

const stats = [
  { num: "2000+", label: "精选话题" },
  { num: "860万+", label: "网友热评" },
  { num: "30万+", label: "表情包收藏" },
  { num: "98%", label: "网友吃瓜满意" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="container-page">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="heading-font text-2xl leading-snug text-foreground-950 md:text-3xl">
              关于「明星吃瓜·现场」
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              我们是一群爱凑热闹、更爱看弹幕的吃瓜群众。每天从热搜、评论区、弹幕和各种名场面里，帮你把最精彩的那部分热评、表情包和神梗段子都挑出来。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
              内容不编造、不传谣，只做网友真实反应的搬运工与精选师。理性吃瓜、友善发言，是我们和你共同的约定。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl bg-background-100 p-4 text-center"
                >
                  <p className="heading-font text-2xl text-primary-600">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {features.map((f, i) => (
              <div
                key={f.title}
                className={`rounded-2xl bg-background-100 p-6 ${
                  i % 3 === 2 ? "sm:col-span-2" : ""
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-xl ${
                    i % 2 === 0
                      ? "bg-primary-100 text-primary-600"
                      : "bg-accent-100 text-accent-700"
                  }`}
                >
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-900">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">
                  {f.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* 网友口碑 */}
        <div className="mt-14">
          <h2 className="mb-6 text-center heading-font text-2xl text-foreground-950 md:text-3xl">
            吃瓜群众怎么说
          </h2>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {[
              { n: "一颗糖", t: "每次新瓜出来，第一时间就来这看热评，比看正片还上头，评论区人均段子手。" },
              { n: "不是路人", t: "表情包区救了我，跟姐妹对线从来不带输的。更新也快，给力！" },
              { n: "深夜emo人", t: "无聊的时候点开神梗段子，一下就乐了，已经成了我的快乐老家。" },
            ].map((p) => (
              <figure
                key={p.n}
                className="rounded-2xl bg-background-100 p-6"
              >
                <div className="flex gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-6 text-foreground-700">
                  “{p.t}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-2 text-sm font-bold text-foreground-800">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                    {p.n.slice(0, 1)}
                  </span>
                  {p.n}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}